import type { RouteSeoEntry } from '@/config/seo';

/**
 * Per-page SEO: the single source of truth for all indexable routes. The sitemap, the
 * prerender and the client-side head all read it. Titles <= 60 chars, descriptions 70-160
 * (src/config/seo.test.ts).
 */
export const seoMeta: Record<string, RouteSeoEntry> = {
  '/': {
    title: 'Physician-Owned Hospitalists | Alliance Health Physicians',
    description:
      'Physician-owned hospital medicine in Southfield, MI: 24/7 hospitalist, observation unit, nursing home and transitional care focused on outcomes and cost.',
  },
  '/hospital-leaders': {
    title: 'For Hospital Leaders | Alliance Health Physicians',
    description:
      'Partner with Alliance Health Physicians for 24/7 hospitalist coverage, lower length of stay and metric-driven cost reduction from a physician-owned group.',
  },
  '/clinicians': {
    title: 'For Clinicians & Careers | Alliance Health Physicians',
    description:
      'Join a physician-owned hospital medicine group: ownership pathways, collaborative practice and clinical excellence in inpatient and post-acute care.',
  },
  '/patients': {
    title: 'For Patients & Families | Alliance Health Physicians',
    description:
      'How we care for you in the hospital, in observation, in the nursing home and after you go home, with clear communication and coordinated care.',
  },
  '/services/hospitalist-medicine': {
    title: 'Hospitalist Medicine Services | Alliance Health Physicians',
    description:
      '24/7 physician-led hospitalist medicine: comprehensive inpatient coverage focused on quality metrics, efficiency and better patient outcomes.',
  },
  '/services/observation-units': {
    title: 'Observation Unit Management | Alliance Health Physicians',
    description:
      'Observation unit management with efficient protocols, a shorter length of stay and coordinated care for short-stay hospital patients.',
  },
  '/services/nursing-home-services': {
    title: 'Nursing Home & SNF Medical Care | Alliance Health Physicians',
    description:
      'On-site medical care for skilled nursing facilities: fewer hospital transfers, collaborative facility partnerships and 24/7 clinical availability.',
  },
  '/services/im-consultations': {
    title: 'Internal Medicine Consultations | Alliance Health Physicians',
    description:
      'Internal medicine consultations for psychiatric and specialty units and complex inpatients, with timely IM expertise for specialty care teams.',
  },
  '/services/surgical-specialty-support': {
    title: 'Surgical Specialty Support | Alliance Health Physicians',
    description:
      'Perioperative medical co-management for surgical specialties: medication optimization, complication prevention and coordinated recovery.',
  },
  '/services/transitional-care-program': {
    title: 'Transitional Care Program | Alliance Health Physicians',
    description:
      'A transitional care program that reduces readmissions: post-discharge follow-up, care coordination and continuity from hospital to home or SNF.',
  },
};
